import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _EVENT_TWO_FACTOR_MAP;

import { ETwoFactorType } from '../../types/authentication';
export var EVENT_TWO_FACTOR_MAPPER = (_EVENT_TWO_FACTOR_MAP = {}, _defineProperty(_EVENT_TWO_FACTOR_MAP, ETwoFactorType.Phone, 'phone_'), _defineProperty(_EVENT_TWO_FACTOR_MAP, ETwoFactorType.Email, 'email_'), _EVENT_TWO_FACTOR_MAP);